import { render, staticRenderFns } from "./WhatsappNewsletterGeneralInfos.vue?vue&type=template&id=d405ea9e&scoped=true&"
import script from "./WhatsappNewsletterGeneralInfos.vue?vue&type=script&lang=js&"
export * from "./WhatsappNewsletterGeneralInfos.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappNewsletterGeneralInfos.vue?vue&type=style&index=0&id=d405ea9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d405ea9e",
  null
  
)

export default component.exports